$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  removeButtonClass();
  subpageHero();
  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);

    lineupButtonsGrid($element);
  });
});

$(window).load(function () {
  setTimeout(countdownDatesFormat, 1000);
  changeHtmlTag();
  modifySignup();
});

// Show only the first 3 letters of the month in the countdown date
function countdownDatesFormat() {
  const dateText = $('#eventDates').text();
  const firstWord = dateText.split(' ')[0];
  const shortenedMonth = firstWord.substring(0, 3);
  $('#eventDates').text(dateText.replace(firstWord, shortenedMonth));
}

// Change Sponsors Title HTML Tag
function changeHtmlTag() {
  const sponsorsTitle = $('.homepageh1').text();
  $('.homepageh1').replaceWith(`<h2 class="homepageh1">${sponsorsTitle}</h2>`);
}

// Remove the "button" class from the "Get Updates" icon
function removeButtonClass() {
  $('.emailInputSubmit a').each(function () {
    $(this).removeClass('button').text('');
  });
}

// Create Subpage Hero Image
function subpageHero() {
  if ($('body').hasClass('subpage')) {
    const headerHeight = $('header').height();
    const hero = $('.entityContainerRow.rowIndex-1');
    const heroImage = hero.find('.TextMediaModule').first().find('img');
    const heroImagePath = getSrc(heroImage);
    const cleanImgPath = heroImagePath.replace(/(?=[() ])/g, '\\');

    function createHero() {
      hero.find('.TextMediaModule').first().hide();
      $(
        '<div class="hero-image" style="background-image: url(' + cleanImgPath + ')"></div>',
      ).insertAfter('header');
      $('.hero-image').css('margin-top', headerHeight);
    }
    createHero();
  }
}

function getSrc(el) {
  return el.attr('src') ? el.attr('src') : el.attr('data-src');
}

// Triggers the email submit button when the "Sign Up Now!" button is clicked
function modifySignup() {
  const submitBtn = $('.emailSubmitButton');
  const signupBtn = $('.email-signup-content .button');

  signupBtn.on('keypress click', function (e) {
    e.preventDefault();
    submitBtn.click();
  });
}

function lineupButtonsGrid(lineup) {
  const containerSize = lineup.width();
  const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
  const icons = buttonContainer.find('.featureLineup-social');
  const buttons = buttonContainer.find('.featureLineup-buynow');

  // if icons length + buttons length is greater than containerSize then add class "column" to buttonContainer
  if (icons.width() + buttons.width() > containerSize - 20) {
    buttonContainer.addClass('column');
  }

  // remove icons if there 0 children

  if (!icons.children().length) {
    icons.remove();
  }
}
